import {toDisplayYearMonth} from '../../../utils/DateUtils';

const EnrollmentTableColumns = () => {
  return [
    {
      dataIndex:'monthYear',
      key: 'monthYear',
      title: 'Month',
      render: (_, row) => toDisplayYearMonth(`${row.monthYear}01`),
    },
    {
      dataIndex:'numEnrolled',
      key: 'numEnrolled',
      title: '# Enrollments',
    },
    {
      dataIndex:'numDocSubmitted',
      key: 'numDocSubmitted',
      title: '# Documents Submitted',
    },
    {
      dataIndex:'numPaymentsDone',
      key: 'numPaymentsDone',
      title: '# Payments Done',
    },

  ];
};

export default EnrollmentTableColumns;
